import TechItem from '../../common/TechItem'
import { useEffect } from 'react'
import '../../Technology.css'

const Secretary = () => {

    useEffect(() => {
        document.title = 'Séneca facilita el trabajo a los Secretarios generando vídeo-actas'
        window.scrollTo(0, 0)
    }, []);

    return (

        <TechItem
            title={'Séneca facilita el trabajo a los Secretarios generando vídeo-actas'}
            imageURL={'/images/cabecera-1.jpg'}
            date={'29 abril, 2016'}
            textArray={[
                "<p className='middle-section-label'>Séneca, un software creado expresamente para la gestión de contenidos audiovisuales en entornos institucionales, permite que los Secretarios puedan certificar el vídeo y vincularlo al acta.</p>",
                "<p className='middle-section-label'>Así, el vídeo se transforma en un diario literal de sesiones: Séneca gestiona la autenticidad e integridad de la vídeo-acta con la firma del Secretario mediante certificado digital o DNI-e, así como su validación pública. En un solo documento, se guardan en el repositorio para ser consultados y contrastados con total transparencia.</p>",
                "<p className='middle-section-label'>Séneca es la solución que hace más fácil la grabación y asegura la acreditación de su autenticidad e integridad por el Secretario.</p>",
            ]}
        />
    )

}

export default Secretary